import { render } from "./i18n-toggle-new.vue?vue&type=template&id=6265b837&scoped=true"
import script from "./i18n-toggle-new.vue?vue&type=script&lang=js"
export * from "./i18n-toggle-new.vue?vue&type=script&lang=js"

import "./i18n-toggle-new.vue?vue&type=style&index=0&id=6265b837&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/security/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6265b837"]])

export default __exports__